var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.isAvailable
    ? _c(
        "b-btn",
        {
          staticClass: "btn-card-action btn-card-action-light my-1",
          attrs: {
            to: { name: "PurchasesShow", params: { id: _vm.purchase.id } },
          },
        },
        [_vm._v("Сделать не срочной")]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }